const locations = [
  {
    id: 1,
    name: "Surendranagar",
    project: "Surendranagar Site",
    area: "Surendranagar, Gujarat",
    lat: 22.728392,
    lng: 71.637077,
    image: "/images/surendranagar.jpg",
    description: "Project site in Surendranagar, Gujarat",
  },
  {
    id: 2,
    name: "Pavagada Solar Project",
    project: "Pavagada Solar Project",
    area: "Pavagada, Karnataka",
    lat: 14.031,
    lng: 77.264,
    image: "/images/pavagada.jpg",
    description: "Solar project in Pavagada, Karnataka",
  },
  {
    id: 3,
    name: "Kalaburagi Site",
    project: "Kalaburagi Renewable Project",
    area: "Kalaburagi, Karnataka",
    lat: 17.320486,
    lng: 76.839752,
    image: "/images/kalaburagi.jpg",
    description: "Renewable project in Kalaburagi, Karnataka",
  },
  {
    id: 4,
    name: "Karur Site",
    project: "Karur Project",
    area: "Karur, Tamil Nadu",
    lat: 10.9601,
    lng: 78.0766,
    image: "/images/karur.jpg",
    description: "Project location in Karur, Tamil Nadu",
  },
  {
    id: 5,
    name: "Trichy Site",
    project: "Trichy Project",
    area: "Trichy, Tamil Nadu",
    lat: 10.7905,
    lng: 78.7047,
    image: "/images/trichy.jpg",
    description: "Project location in Tiruchirappalli (Trichy), Tamil Nadu",
  },
  {
    id: 6,
    name: "Anantapur Site",
    project: "Anantapur Project",
    area: "Anantapur, Andhra Pradesh",
    lat: 14.685564,
    lng: 77.595406,
    image: "/images/ananthapur.jpg",
    description: "Project location in Anantapur, Andhra Pradesh",
  },
  {
    id: 7,
    name: "Jammalamadugu Site",
    project: "Jammalamadugu Project",
    area: "Jammalamadugu, Andhra Pradesh",
    lat: 14.852,
    lng: 78.226, 
    image: "/images/jammalamadugu.jpg",
    description: "Project near Jammalamadugu, Andhra Pradesh",
  },
  {
    id: 8,
    name: "Bhuj Site",
    project: "Bhuj Project",
    area: "Bhuj, Gujarat",
    lat: 23.242001,
    lng: 69.666931,
    image: "/images/bhuj.jpg",
    description: "Project location in Bhuj, Gujarat",
  },
];

export default locations;
